export default {
    install: (Vue) => {
        Vue.mixin({
            data() {
                return {
                    USER_TYPE_MIXIN: {
                        isAdm: this.$store ? this.$store.state.user.userAdm : false,
                        isSponsor: this.$store ? this.$store.state.user.companyType == 0 : false,
                        isProvider: this.$store ? this.$store.state.user.companyType == 1 : false,
                        isBuyer: this.$store ? this.$store.state.user.companyType == 2 : false,
                        isBackOffice: this.$store ? this.$store.state.user.companyType == 3 && this.$store.state.user.partnerAdm : false,
                    },
                    USER_TYPES_MIXIN: ['sponsor', 'provider', 'buyer'],
                    windowWidth: window.innerWidth
                }
            },
            mounted() {
                this.$nextTick(() => {
                    window.addEventListener('resize', this.onResize);
                })
            },

            beforeDestroy() {
                window.removeEventListener('resize', this.onResize);
            },

            methods: {
                onResize() {
                    this.windowHWidth = window.innerWidth
                }
            }
        })
    }
}